export function NavToggle() {
    document.addEventListener('DOMContentLoaded', () => {
        const toggles = document.querySelectorAll('[data-nav-toggle]');

        toggles.forEach((toggle) => {
            toggle.addEventListener('click', () => {
                document.documentElement.classList.toggle('has-nav-visible');
                toggle.classList.toggle('is-active');

                const targetSelector = toggle.dataset.navToggle;
                if (targetSelector) {
                    document.querySelector(targetSelector)?.classList.toggle('is-visible');
                }
            });
        });
    });
}